import { TableBody, TableCell, TableRow } from "@windmill/react-ui";

import VendorDrawer from "components/drawer/VendorDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewVendorModal";
import VendorRemarks from "components/modal/VedorRemarks";
import EditDeleteButton from "components/table/EditDeleteButton";
import Tooltip from "@mui/material/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useContext, useState } from "react";
import { FiEye } from "react-icons/fi";
import ShowHideButton from "components/table/ShowHideButton";
import ShowHideButtonBlock from "components/table/ShowHideButtonBlock";
import RemarkModal from "components/modal/RemarkModal";
import { Modal, ModalBody } from "@windmill/react-ui";
import VendorStatus from "components/table/VendorStatus";
import DriverAproveRejectModel from "components/modal/DriverAproveRejectModel";
import VendorServices from "services/VendorServices";
import { notifyError, notifySuccess } from "utils/toast";
import { SidebarContext } from "context/SidebarContext";

const VendorTable = ({
  vendor,
  perpage,
  currentPage,
  hideEdit,
  tab,
  hideDelete,
}) => {
  const {
    title,
    serviceId,
    serviceBlock,
    handleModalOpen,
    handleView,
    handleUpdate,
    handleBlock,
  } = useToggleDrawer();
  const { setIsUpdate } = useContext(SidebarContext);
  const [isOpen, setIsOpen] = useState(false);
  const [openRemarks, setOpenRemarks] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const [selectedVendor, setSelectedVendor] = useState(null)
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [changesModalOpen, setChangesModalOpen] = useState(false);
  const [changesModalData, setChangesModalData] = useState([]);


  const handleStatusChange = (vendorId) => {
    setSelectedVendor({ id: vendorId });
    setIsRemarkModalOpen(true);
  };

  const handleModalAction = async (action, remark) => {
    try {
      const payload = {};

      if (action === "approve") {
        payload.status = 1
        payload.remark = "";
      } else if (action === "reject") {
        payload.status = 0
        payload.remark = remark;
      }

      const response = await VendorServices.vendorApproveReject(
        selectedVendor.id,
        payload
      );

      if (response.status) {
        setIsUpdate(true);
        return notifySuccess(response.message);
      } else {
        return notifyError(response.message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      return notifyError(error?.response?.data?.message||error?.response?.message||"Error updating status.");
    } finally {
      setIsRemarkModalOpen(false);
      setSelectedVendor(null);
    }
  };

  const handleSuccessModalOpen = () => {
    setIsOpen(true);
  };

  const handleSuccessModalClose = () => {
    setIsOpen(false);
  };
  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <VendorRemarks
        isOpen={openRemarks}
        selectedData={selectedData}
        onClose={() => setOpenRemarks(false)}
      />
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={vendor} />

      <MainDrawer>
        <VendorDrawer id={serviceId} onModalOpen={handleSuccessModalOpen} />
      </MainDrawer>

      {isRemarkModalOpen && (
        <DriverAproveRejectModel
          isOpen={isRemarkModalOpen}
          onClose={() => setIsRemarkModalOpen(false)}
          title="Approve or Reject"
          onYesClick={() => handleModalAction("approve", "Approved")}
          onRejectClick={(remark) => handleModalAction("reject", remark)}
        />
      )}

      <TableBody>
        {vendor?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id_client}>
            <TableCell className="text-center text-sm">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.reference_no}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.company_name}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.franchise_partner_name}
            </TableCell>
            <TableCell className="text-center text-sm">{data.city}</TableCell>
            <TableCell className="text-center text-sm">
              {data.authorized_person}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.contact_no}
            </TableCell>
            {tab == 0 && (
              <TableCell className="text-sm text-center">
                {data.approval_status?.type === 'update' && Array.isArray(data.pending_changes) && data.pending_changes.length > 0 ? (
                  <button
                    onClick={() => { setChangesModalData(data.pending_changes); setChangesModalOpen(true); }}
                    className="text-xs text-blue-600 underline hover:text-blue-800 cursor-pointer"
                  >
                    {data.pending_changes.length} change{data.pending_changes.length > 1 ? 's' : ''}
                  </button>
                ) : (
                  <span className="text-gray-400 text-xs">—</span>
                )}
              </TableCell>
            )}
            {tab == 0 && (
              <TableCell className="text-center text-sm">
                <span className="block text-yellow-600 font-semibold text-xs">
                  {data.approval_status?.type === 'update' ? 'Update Pending' : 'New Registration'}
                </span>
                {hideEdit&&(
                <span
                  className="mt-1 inline-block text-sm text-blue-600 cursor-pointer hover:text-blue-800"
                  onClick={() => handleStatusChange(data.id)}
                >
                  Action
                </span>
                )}

              </TableCell>
            )}
            {tab == 1 && <TableCell className="text-center">

              <>
                <div
                  className={`text-xs font-semibold mt-1 ${
                    data.actual_status === 'blocked'
                      ? "text-red-600"
                      : data.actual_status === 'active'
                        ? "text-green-600"
                        : "text-gray-500"
                  }`}
                >
                  {data.actual_status === 'blocked'
                    ? "Blocked"
                    : data.actual_status === 'active'
                      ? "Active"
                      : "Inactive"}
                </div>
                {hideEdit && (
                  <VendorStatus
                    id={data.id}
                    isActive={data.is_active}
                    isBlocked={data.is_blocked}
                    title_block="Vendor"
                  />
                )}
              </>
            </TableCell>
            }

            <TableCell className="text-center">
              <span
                className="text-sm cursor-pointer"
                onClick={() => {
                  setSelectedData(data);
                  setOpenRemarks(true);
                }}
              >
                view
              </span>
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                  <button
                    onClick={() => handleView(data.id, "Vendor Details")}
                    className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                  >
                    <FiEye />
                  </button>
                </div>
                <EditDeleteButton
                  title={"Vendor"}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideDelete={hideDelete}
                  hideEdit={hideEdit}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      <Modal isOpen={changesModalOpen} onClose={() => setChangesModalOpen(false)}>
        <div className="flex justify-between items-center p-4 border-b">
          <p className="text-base font-semibold">Requested Changes</p>
          <button onClick={() => setChangesModalOpen(false)} className="text-gray-500 hover:text-gray-700 focus:outline-none">
            <strong>✕</strong>
          </button>
        </div>
        <ModalBody>
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-gray-600">Field</th>
                <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-red-500">Before</th>
                <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-green-600">Requested</th>
              </tr>
            </thead>
            <tbody>
              {changesModalData.map((c, i) => (
                <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-3 py-2 border border-gray-200 font-medium text-gray-700">{c.label}</td>
                  <td className="px-3 py-2 border border-gray-200 text-red-500">{c.old || '—'}</td>
                  <td className="px-3 py-2 border border-gray-200 text-green-600 font-semibold">{c.new || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </ModalBody>
      </Modal>

      <Modal isOpen={isOpen} onClose={handleSuccessModalClose}>
        <div className="flex justify-between items-center p-2">
          <p className="text-lg font-semibold">Success</p>
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={handleSuccessModalClose}
          >
            <strong>✕</strong>
          </button>
        </div>
        <ModalBody>
          <div>
            <p>Vendor Added Successfully</p>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default VendorTable;
